<template>
  <div class="container">
    <div class="d-flex justify-content-between align-items-center my-4">
      <h3>Controle de Demanda FGTS</h3>
      <!--<b-nav-form @submit.prevent="searchFieldAction(searchData)">
                <b-form-input v-model="searchData" v-on:keyup="searchFieldAction(searchData)"
                 size="sm" class="mr-sm-2" placeholder="Localizar proposta..."></b-form-input>
                 <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button> 
                </b-nav-form>-->
      <button class="btn btn-primary" title="Criar Nova Proposta">
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <hr />
    <div>
      <div class="text-center mt-5" v-if="preloader">
        <b-spinner
          variant="warning"
          type="grow"
          label="Large Spinner"
        ></b-spinner>
        <h5 class="lead">Carregando...</h5>
      </div>

      <h3 class="text-center lead mt-5" v-if="fgtsDemands == '' && !preloader">
        Nenhuma demanda FGTS encontrada
      </h3>

      <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="item of fgtsDemands" :key="item.id">
          <div class="">
            <div class="card-body">
              <img
                src="http://placehold.it/45x45"
                class="float-left rounded-circle"
              />
              <div class="message">
                <h6 class="card-title">Pedro de Oliveira Esteves - {{ item.proposal_id }} CPF: 123.456.789.09</h6>
                <small class="card-subtitle mb-2 text-muted">
                  Nº da Operação: 
                  {{ item.operationNumber }} -
                  
                  Valor da Operação: 
                  R$ {{ item.amount }}
                  <br>
                  <small>
                    Criado em {{item.created.toDate().toLocaleDateString()}} às {{item.created.toDate().toLocaleTimeString()}}
                    e atualizado em  {{item.updated.toDate().toLocaleDateString()}} às {{item.updated.toDate().toLocaleTimeString()}}
                  </small>
                </small>
                <!--<div class="float-right" title="Ativação do usuário">
                  <b-form-checkbox
                    switch
                    v-model="item.emailVerified"
                    @change="desactiveUser(item.uid)"
                  >
                    {{ item.emailVerified }}</b-form-checkbox
                  >
                </div>-->
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'FgtsDemand',
  data() {
    return {
      searchData: '',
      classCss: 'text-primary'
    };
  },
  methods: {
    ...mapActions(['searchFieldAction', 'getFgtsDemand']),
    desactiveUser(uid) {}
  },
  computed: {
    ...mapState(['preloader', 'fgtsDemands', 'users']),
    ...mapGetters(['proposalFilterOfSearch'])
  },
  created() {
    this.getFgtsDemand();
  }
};
</script>

<style scoped>
ul {
  list-style: none;
}
h6 {
  margin: 0;
}
div .card-body {
  padding: 0.25rem;
}
.card-body .message {
  padding-left: 60px;
}

.card .card-body .actions {
  margin-top: 5px;
}
</style>
